export enum EnumEntradaOpcoes {
  EntradaManual,
  ImportarXML,
  EscanearChaveAcesso
}
